import type { ListKind } from '@kestrel/shared/domain';

/** Registry lists, proposals and the agency review. Owner: settings-admin. Add; never rename. */
export const listKeys = {
  all: ['lists'] as const,
  /** `GET /api/lists/:list/entries`. */
  entries: (list: ListKind, filters: object = {}) => ['lists', 'entries', list, filters] as const,
  entriesOf: (list: ListKind) => ['lists', 'entries', list] as const,
  /** `GET /api/lists/:list/impact`. */
  impact: (list: ListKind, query: object) => ['lists', 'impact', list, query] as const,
  /** `GET /api/lists/versions`. */
  versions: () => ['lists', 'versions'] as const,
  /** `GET /api/list-proposals`. */
  proposals: (filters: object = {}) => ['lists', 'proposals', filters] as const,
  /** Every `GET /api/list-proposals`, whatever its filter. */
  proposalsAll: () => ['lists', 'proposals'] as const,
  /** `GET /api/agency-review`. */
  agencyReview: () => ['lists', 'agency-review'] as const,
};
